module.exports = __webpack_public_path__ + "assets/img/title-7573f46f.png";